<template>
  <div class="gnb-main" :class="{ focusd: isFocusOn }">
    <div
      @mouseover="isFocusOn = true"
      @mouseout="isFocusOn = false"
      @click="enterKeyProc"
    >
      <img
        v-if="isFocusOn"
        class="return_ic"
        src="@/assets/return-detail-f-ic.png"
      />
      <img v-else class="return_ic" src="@/assets/return-detail-ic.png" />
    </div>
    <div v-if="listItems.count > 0" class="inner">
      <div class="game-title singleline">{{ gameTypeName }}</div>
      <div class="line"></div>
      <div class="team-name singleline">{{ leagueName }}</div>
      <div class="line" v-if="leagueName"></div>
      <div class="team-name singleline">{{ gameInfo.name }}</div>
      <div class="small-line">영상 {{ listItems.count }}개</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActiveVue: true,
      isFocusOn: false,
      focusedIndex: 0,
      selectedIndex: 0,
      gameInfo: {},
      gameTypeName: "",
    };
  },
  computed: {
    keyInput() {
      return this.$store.getters.keyInput;
    },
    fousedView() {
      return this.$store.getters.focusedView;
    },
    listItems() {
      return this.$store.getters.programDetailList || [];
    },
    gameTypes() {
      return this.$store.getters.gameTypes;
    },
    maxIndex() {
      return this.listItems.list.length;
    },
    title() {
      return this.$route.params.title;
    },
    leagueName() {
      return this.listItems.list[0].leagueName;
    },
  },
  watch: {
    fousedView(val, oldVal) {
      if (val == "gnb") {
        this.isFocusOn = true;
      } else {
        this.isFocusOn = false;
      }
    },
    keyInput(val, oldVal) {
      if (this.isActiveVue && val.focusView == "gnb") {
        switch (val.key) {
          case "ArrowRight":
            this.rightKeyProc(val);
            break;
          case "Enter":
            this.enterKeyProc(val);
            break;
          case "Backspace":
            this.backKeyProc(val);
            break;
        }
      }
    },
  },
  methods: {
    rightKeyProc(keyInput) {
      this.focusedIndex = this.selectedIndex;
      this.$store.commit("SET_FOCUSED_VIEW", "default");
    },
    enterKeyProc(keyInput) {
      this.$router.go(-1);
    },
    backKeyProc(keyInput) {
      this.$router.go(-1);
    },
  },

  created() {
    this.$store.dispatch("FETCH_GAME_TYPE").then((response) => {
      this.$store
        .dispatch("FETCH_PROGRAM_DETAIL_INFO", this.$route.params.programId)
        .then((response) => {
          this.gameInfo = response.data;
          this.gameTypes.forEach((element) => {
            if (element.id == this.gameInfo.gameTypeId) {
              this.gameTypeName = element.name;
            }
          });
        })
    });
  },

  activated() {
    this.isActiveVue = true;
  },
  deactivated() {
    this.isActiveVue = false;
  },
};
</script>

<style scoped>
.gnb-main {
  position: absolute;
  z-index: 10;
  left: 0;
  top: 0;
  width: 458px;
  height: 1080px;
  background-color: rgba(30, 30, 30, 0.95);
  transition: width 0.2s;
}
.return_ic {
  position: absolute;
  width: 64px;
  height: 64px;
  top: 54px;
  left: 40px;
}
.inner {
  top: 188px;
  margin-left: 40px;
}
.menu.focused {
  background-color: rgba(62, 62, 62, 0.95);
  border-top: solid 2px #eeeeee;
  border-bottom: solid 2px #eeeeee;
  /* margin-top: -2px; */
  /* margin-bottom: -2px; */
}
.game-title {
  margin-bottom: 24px;
  font-size: 40px;
  line-height: 1.4;
  color: #eeeeee;
}
.team-name {
  margin-top: 12px;
  font-size: 28px;
  line-height: 1.14;
  color: #eeeeee;
}

.small-line {
  margin: 24px 0;
  font-size: 24px;
  line-height: 1.33;
  color: #707070;
}
.line {
  width: 378px;
  height: 2px;
  margin: 31px 0 38px;
  background-color: #2e2e2e;
}

@media all and (min-width: 0px) and (max-width: 1280px) {
  .gnb-main {
    position: absolute;
    z-index: 10;
    left: 0;
    top: 0;
    width: 280px;
    height: 100vh;
    background-color: rgba(30, 30, 30, 0.95);
    transition: width 0.2s;
  }
  .return_ic {
    position: absolute;
    width: 48px;
    height: 48px;
    top: 32px;
    left: 32px;
  }
  .inner {
    top: 128px;
    margin-left: 32px;
  }
  .menu.focused {
    background-color: rgba(62, 62, 62, 0.95);
    border-top: solid 2px #eeeeee;
    border-bottom: solid 2px #eeeeee;
    /* margin-top: -2px; */
    /* margin-bottom: -2px; */
  }
  .game-title {
    margin-bottom: 16px;
    font-size: 26px;
    line-height: 1;
    color: #eeeeee;
    font-weight: bold;
  }
  .team-name {
    margin-top: 12px;
    font-size: 18px;
    line-height: 1;
    color: #ffffff;
  }

  .small-line {
    margin: 12px 0;
    font-size: 18px;
    line-height: 1;
    color: #888888;
  }
  .line {
    width: 216px;
    height: 1px;
    margin: 16px 0;
    background-color: #2e2e2e;
  }
}
</style>